import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
    Grid,
    Box,
    Typography,
    Button,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Modal,
} from "@material-ui/core";
import Search from "@material-ui/icons/Search";

import EmpresaService from "../../services/empresaService";
import modeloService from "../../services/modeloService";
import usuarioService from "../../services/usuarioService";
import TableEmpresas from "../../components/TableEmpresas";
import { Link as RouterLink, useHistory } from "react-router-dom";

const Empresas = () => {
    const history = useHistory();
    const [empresas, setEmpresas] = useState([]);

    const [campoBuscar, setCampoBuscar] = useState("");

    const [pagina, setPagina] = useState(1);
    const [limite, setLimite] = useState(10);
    const [total, setTotal] = useState(0);

    const [intervalLoop, setIntervalLoop] = useState(true);

    const getJsonFilter = () => {
        return {
            buscar: campoBuscar,
            page: pagina,
        };
    };

    const cadastroEmpresa = async () => {
        history.push("/empresas/cadastro");
    };

    const buscarEmpresas = async (
        busca = "",
        page = undefined,
        interval = false
    ) => {
        if (!interval) {
            setIntervalLoop(false);
        }

        const paginaRequest = page ? page : 1;
        setPagina(paginaRequest);

        const result = await EmpresaService.buscarEmpresas(
            paginaRequest,
            limite,
            busca
        );

        setEmpresas(result.empresas);
        setTotal(result.total);
        if (!interval) {
            setIntervalLoop(true);
        }
    };

    const changeValue = {
        buscar: (value) => setCampoBuscar(value),
    };

    const handleChange = async (event) => {
        const key = event.target.name;
        const value = event.target.value;

        if (key && changeValue[key]) {
            changeValue[key](value);
            let paramns = getJsonFilter();
            paramns[key] = value;
            await buscarEmpresas(paramns.buscar);
        }
    };

    const handleChangePage = async (event, newPage) => {
        let paramns = getJsonFilter();

        await buscarEmpresas(paramns.buscar, newPage + 1);
    };

    useEffect(async () => {
        let paramns = getJsonFilter();

        await buscarEmpresas(paramns.buscar, paramns.page);
    }, []);

    useEffect(() => {
        if (intervalLoop) {
            const interval = setInterval(async () => {
                let paramns = getJsonFilter();
                if (intervalLoop) {
                    await buscarEmpresas(paramns.buscar, paramns.page, true);
                }
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [intervalLoop]);

    const configPortal = usuarioService.getConfigPortal();

    const camposListagem = configPortal?.campos_listagem
        ? configPortal.campos_listagem
        : [];

    const espacoListagem = configPortal?.espaco_listagem
        ? configPortal.espaco_listagem
        : 12;

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6">
                                    <Box fontWeight="bold">Empresas</Box>
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={cadastroEmpresa}
                                >
                                    Nova empresa
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Grid item md={2} xs={12}>
                                <TextField
                                    label="Buscar"
                                    fullWidth
                                    variant="outlined"
                                    type="text"
                                    size="small"
                                    value={campoBuscar}
                                    name="buscar"
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Box
                marginTop="1.5rem"
                width="80rem"
                maxWidth="95vw"
                marginBottom="1rem"
                minHeight="40rem"
            >
                <TableEmpresas
                    rows={empresas}
                    pagina={pagina - 1}
                    limite={limite}
                    total={total}
                    camposListagem={camposListagem}
                    padding={espacoListagem}
                    handleChangePage={handleChangePage}
                />
            </Box>

            {/* MODAL
            <Modal
                open={abrirModal}
                onClose={fecharModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Grid>
                    <ModalRelatorios
                        submitEmpresa={submitEmpresa}
                        modelos={modelos}
                        fecharModal={fecharModal}
                        loading={loading}
                    />
                </Grid>
            </Modal> */}
        </Grid>
    );
};

export default Empresas;
